import _ from 'lodash';
import {Directive, Module} from 'app/decorators';


@Module({
    name: "app.directives.fadeout",
})
@Directive('fadeIn', function($timeout, $animate){
    "ngInject";
    return {
        restrict: 'A',
        scope: {
            fadeIn: '=',
            callback: '&'
        },
        link: function linkingFunction(scope, element) {
            let classes = 'fadein-start animated fade-in';
            let watcher = scope.$watch('fadeIn', function watchFunction(value) {
                if (value) {
                    let $promise = $animate.addClass(element, classes);
                    if (scope.callback) {
                        $promise.then(scope.callback);
                    }
                } else {
                    $animate.removeClass(element, 'fade-in');
                }
            });

            scope.$on('$destroy', function () {
                watcher();
            })
        }
    };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/fade.out.js